<template>
  <div class="account-panel">
    <div class="account-panel-title">
      <h3>{{title}}</h3>
    </div>
    <div class="account-panel-body">
      <slot></slot>
    </div>
  </div>
</template>


<script>


  export default {
    props: ['title'],
    components: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/AccountPanel.vue